/* TICHO collection intro: collapse the server-rendered SEO intro to ~3 lines
   with an accessible "Czytaj więcej" / "Zwiń" toggle. Progressive
   enhancement only: without this script the full text is shown. */
(function () {
  function init(wrap) {
    if (wrap.dataset.tichoIntroReady) return;
    var body = wrap.querySelector('.ticho-intro__body');
    var toggle = wrap.querySelector('.ticho-intro__toggle');
    if (!body || !toggle) return;
    var lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 24;
    var lines = parseFloat(getComputedStyle(wrap).getPropertyValue('--ticho-intro-lines')) || 3;
    var collapsed = Math.round(lineHeight * lines);
    if (body.scrollHeight <= collapsed + lineHeight * 0.75) return;
    wrap.dataset.tichoIntroReady = 'true';
    wrap.style.setProperty('--ticho-intro-collapsed', collapsed + 'px');
    wrap.classList.add('is-collapsible');
    toggle.hidden = false;
    var timer;
    toggle.addEventListener('click', function () {
      var open = !wrap.classList.contains('is-open');
      clearTimeout(timer);
      wrap.style.setProperty('--ticho-intro-full', body.scrollHeight + 'px');
      if (!open) body.offsetHeight; // fix the start height before collapsing
      wrap.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.textContent = open ? 'Zwiń' : 'Czytaj więcej';
      if (open) timer = setTimeout(function () { wrap.style.setProperty('--ticho-intro-full', 'none'); }, 400);
    });
  }
  function run() { document.querySelectorAll('[data-ticho-intro]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
